import React from 'react';
import './DispatchBoard.scss';
import { CardBody, CardTitle } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cls from 'classnames';
import { faHardHat, faMinusCircle } from '@fortawesome/free-solid-svg-icons';
import { ConfirmationStatus } from '../cancelConfirmation/CancelConfirmation';
import { ContractTimesheetResponsibilityType } from '../tenant/Tenant';
import { LocalizationKeys as l } from '../Common';
import JobResourceOverrideDetails from './JobResourceOverrideDetails';
import ManageAssignmentsModal from './ManageAssignmentsModal';

export default class DriverJobFilledAssignment extends React.Component {
    isRemoveAllowed = () => {
        const { group, job, dayInt } = this.props;

        // job.canEdit is backed by whether or not the crew has submitted a timesheet.
        // if we have a timesheet for this crew for this day, we cannot remove the assignment.

        return (
            group.assignment.confirmationStatusId !=
                ConfirmationStatus.CancelPending &&
            !!job.assignments[dayInt].canEdit
        );
    };

    getEquipmentAssignments = () => {
        const { job, dayInt, assignmentIndex, group } = this.props;
        const equipmentAssignments = [];

        for (let i = 0; i < job.assignments[dayInt].equipment.length; i++) {
            const eq = job.assignments[dayInt].equipment[i];
            const staff = job.assignments[dayInt].staff[assignmentIndex];

            if (
                eq.assignedEmployee?.id != null &&
                eq.assignedEmployee?.id == group.assignment?.id
            ) {
                equipmentAssignments.push(eq);
            }

            if (eq.isBroker && staff.isBroker) {
                equipmentAssignments.push(eq);
            }
        }

        return equipmentAssignments;
    };

    getEquipmentAssignmentsToUpdate = () => {
        const { job, dayInt, group } = this.props;
        const employeeId = group.assignment?.id;

        if (employeeId == null) {
            return [];
        }

        return job.assignments[dayInt].equipment.filter(
            (x) =>
                x.assignment &&
                x.assignedEmployee?.id == employeeId
        );
    };

    state = { isRemoveModalOpen: false };

    onRemoveClick = () => {
        const { job, group, dayInt, onRemoveAssignment } = this.props;
        const equipment = this.getEquipmentAssignments().filter(
            (x) => x.assignment
        );
        const equipmentToUpdate = this.getEquipmentAssignmentsToUpdate();

        if (equipment.length === 0 && equipmentToUpdate.length === 0) {
            onRemoveAssignment(job, group, dayInt);
        } else {
            this.setState({ isRemoveModalOpen: true });
        }
    };

    onUpdateModalSave = async (equipmentAssignmentLinks) => {
        const { job, onUpdateEquipmentAssignmentLinks } = this.props;

        this.setState({ isRemoveModalOpen: false });
        await onUpdateEquipmentAssignmentLinks(job, equipmentAssignmentLinks);
    };

    onRemoveModalCancel = () => this.setState({ isRemoveModalOpen: false });

    onRemoveModalSave = async (selectedAssignments) => {
        const { job, dayInt, onRemoveAssignment } = this.props;

        this.setState({ isRemoveModalOpen: false });

        for (const assignment of selectedAssignments) {
            await onRemoveAssignment(job, assignment, dayInt);
        }
    };

    hasEquipmentOverrides = () =>
        this.getEquipmentAssignments().some(
            (equipmentAssignment) =>
                equipmentAssignment.assignment &&
                equipmentAssignment.jobResourceOverride
        );

    onSetCrewLeadClick = () => {
        const { job, setCrewLead, group, dayInt } = this.props;

        if (job.assignments[dayInt].canEdit) {
            setCrewLead(group.jobAssignmentId, job.id);
        }
    };

    render() {
        const { job, group, dayInt, onRemoveAssignment, strings } = this.props;

        const { isRemoveModalOpen } = this.state;
        const crewLead = strings[l.crewLead];
        const equipmentAssignments = this.getEquipmentAssignments();

        return (
            <div className="card staffCard compact job-assignment-card driver-job-filled-assignment-card">
                <div className="w-100">
                    <CardBody>
                        <CardTitle className="text-left d-flex flex-row align-items-center">
                            <table width="100%">
                                <tbody>
                                    <tr>
                                        <td
                                            style={{
                                                border: 0,
                                                padding: 0,
                                            }}
                                        >
                                            <span className="d-flex flex-row align-items-center">
                                                {!group.assignment && (
                                                    <label className="mr-1 dropPlaceholder">{`${group.name}`}</label>
                                                )}

                                                <div className="d-flex flex-column">
                                                    <table>
                                                        <tbody>
                                                            <tr>
                                                                <td
                                                                    style={{
                                                                        border: 0,
                                                                        padding: 0,
                                                                        verticalAlign:
                                                                            'middle',
                                                                    }}
                                                                    width="15%"
                                                                >
                                                                    {this.isRemoveAllowed() && (
                                                                        <>
                                                                            <FontAwesomeIcon
                                                                                title="Remove this personnel"
                                                                                icon={
                                                                                    faMinusCircle
                                                                                }
                                                                                style={{
                                                                                    marginRight:
                                                                                        '10px',
                                                                                }}
                                                                                className="text-danger cursor-pointer"
                                                                                onClick={
                                                                                    this
                                                                                        .onRemoveClick
                                                                                }
                                                                            />
                                                                        </>
                                                                    )}
                                                                </td>
                                                                <td
                                                                    style={{
                                                                        border: 0,
                                                                        padding: 0,
                                                                        textAlign:
                                                                            'left',
                                                                    }}
                                                                >
                                                                    <div className="assignment-main-text">
                                                                        <span className="d-flex flex-row align-items-center">
                                                                            {job.contractTimesheetResponsibilityTypeId ===
                                                                                ContractTimesheetResponsibilityType.CrewLead && (
                                                                                <FontAwesomeIcon
                                                                                    icon={
                                                                                        faHardHat
                                                                                    }
                                                                                    onClick={
                                                                                        this
                                                                                            .onSetCrewLeadClick
                                                                                    }
                                                                                    className={cls(
                                                                                        'mr-1 cursor-pointer crewLeadBadge',
                                                                                        {
                                                                                            isCrewLead:
                                                                                                !!group.isCrewLead,
                                                                                        }
                                                                                    )}
                                                                                    title={
                                                                                        group.isCrewLead
                                                                                            ? crewLead
                                                                                            : `Mark this employee as the ${crewLead}`
                                                                                    }
                                                                                />
                                                                            )}
                                                                            <span>
                                                                                {
                                                                                    group
                                                                                        .assignment
                                                                                        .name
                                                                                }
                                                                                {this.hasEquipmentOverrides() &&
                                                                                    '*'}
                                                                            </span>
                                                                        </span>
                                                                        <JobResourceOverrideDetails
                                                                            override={
                                                                                group.jobResourceOverride
                                                                            }
                                                                        />
                                                                    </div>
                                                                    <span
                                                                        className={`assignment-status-text assignment-status-label ${group.assignment.confirmationStatusName
                                                                            .replace(
                                                                                ' ',
                                                                                ''
                                                                            )
                                                                            .toLowerCase()}`}
                                                                    >
                                                                        {
                                                                            group
                                                                                .assignment
                                                                                .confirmationStatusName
                                                                        }
                                                                    </span>
                                                                </td>
                                                            </tr>
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </span>
                                        </td>

                                        <td
                                            style={{
                                                border: 0,
                                                padding: 0,
                                                verticalAlign: 'middle',
                                                textAlign: 'right',
                                                paddingRight: '4px',
                                            }}
                                        >
                                            <table>
                                                <tbody>
                                                    {equipmentAssignments
                                                        .filter(
                                                            (ea) =>
                                                                ea.assignment
                                                        )
                                                        .map(
                                                            (
                                                                equipmentAssignment,
                                                                i
                                                            ) => {
                                                                return (
                                                                    <tr
                                                                        key={`eqa-${i}`}
                                                                    >
                                                                        <td
                                                                            width="100%"
                                                                            style={{
                                                                                border: 0,
                                                                                padding: 0,
                                                                                verticalAlign:
                                                                                    'middle',
                                                                                textAlign:
                                                                                    'right',
                                                                            }}
                                                                        >
                                                                            {!equipmentAssignment?.isBroker && (
                                                                                <span className="assignment-side-text">
                                                                                    {
                                                                                        equipmentAssignment
                                                                                            .assignment
                                                                                            .description
                                                                                    }
                                                                                    &nbsp;
                                                                                    <span
                                                                                        style={{
                                                                                            fontWeight:
                                                                                                'bold',
                                                                                            color: '#909090',
                                                                                        }}
                                                                                    >
                                                                                        (
                                                                                        {
                                                                                            equipmentAssignment
                                                                                                .assignment
                                                                                                ?.equipmentType
                                                                                                ?.description
                                                                                        }

                                                                                        )
                                                                                    </span>
                                                                                </span>
                                                                            )}

                                                                            {equipmentAssignment?.isBroker && (
                                                                                <span className="assignment-side-text">
                                                                                    {
                                                                                        equipmentAssignment
                                                                                            .assignment
                                                                                            .description
                                                                                    }
                                                                                    &nbsp;
                                                                                    <span
                                                                                        style={{
                                                                                            fontWeight:
                                                                                                'bold',
                                                                                            color: '#909090',
                                                                                        }}
                                                                                    ></span>
                                                                                </span>
                                                                            )}

                                                                            <JobResourceOverrideDetails
                                                                                override={
                                                                                    equipmentAssignment.jobResourceOverride
                                                                                }
                                                                            />

                                                                            <div>
                                                                                <span
                                                                                    className={`text-right assignment-status-text assignment-status-label ${equipmentAssignment.assignment.confirmationStatusName
                                                                                        .replace(
                                                                                            ' ',
                                                                                            ''
                                                                                        )
                                                                                        .toLowerCase()}`}
                                                                                >
                                                                                    {
                                                                                        equipmentAssignment
                                                                                            .assignment
                                                                                            .confirmationStatusName
                                                                                    }
                                                                                </span>
                                                                            </div>
                                                                        </td>

                                                                        <td
                                                                            style={{
                                                                                border: 0,
                                                                                padding: 0,
                                                                                verticalAlign:
                                                                                    'middle',
                                                                            }}
                                                                        >
                                                                            <FontAwesomeIcon
                                                                                title="Remove this equipment"
                                                                                icon={
                                                                                    faMinusCircle
                                                                                }
                                                                                size="lg"
                                                                                className="text-danger cursor-pointer"
                                                                                style={{
                                                                                    marginLeft:
                                                                                        '8px',
                                                                                }}
                                                                                onClick={() => {
                                                                                    onRemoveAssignment(
                                                                                        job,
                                                                                        equipmentAssignment,
                                                                                        dayInt
                                                                                    );
                                                                                }}
                                                                            />
                                                                        </td>
                                                                    </tr>
                                                                );
                                                            }
                                                        )}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </CardTitle>
                    </CardBody>
                </div>
                {isRemoveModalOpen && (
                    <ManageAssignmentsModal
                        job={job}
                        day={this.props.day}
                        employee={group}
                        equipment={equipmentAssignments.filter(
                            (x) => x.assignment
                        )}
                        equipmentToUpdate={this.getEquipmentAssignmentsToUpdate()}
                        onSave={this.onRemoveModalSave}
                        onUpdateSave={this.onUpdateModalSave}
                        onCancel={this.onRemoveModalCancel}
                    />
                )}
            </div>
        );
    }
}
